import React, { useState } from "react";
import { Box, Select, Button, Text } from "grommet";
import { FormClose } from "grommet-icons";
import { useTranslation } from "react-i18next";

const defaultOptions = [
  { id: "prearrival", name: "Pre-arrival" },
  { id: "checkedin", name: "Checked-in" },
  { id: "aftercheckout", name: "After checkout" },
];

export default function ValidStatusesSelect(props) {
  const { t } = useTranslation();
  const { currentValue = [], disabled = false } = props;
  const translatedOptions = defaultOptions.map((option) => ({
    ...option,
    name: t(`validStatuses.${option.id}`),
  }));
  const [options, setOptions] = useState(translatedOptions);

  // Convert currentValue (array of strings) to array of objects
  const currentValueAsObjects =
    currentValue
      ?.map((id) => translatedOptions.find((opt) => opt.id === id))
      .filter(Boolean) || [];

  const onRemoveStatus = (statusId) => {
    const nextSelected = currentValue.filter(
      (selectedStatusId) => selectedStatusId !== statusId,
    );
    props.onChange({ target: { name: props.name, value: nextSelected } });
  };

  const renderStatus = (status) =>
    status && (
      <Button
        key={`status_tag_${status.id}`}
        href="#"
        disabled={disabled}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onRemoveStatus(status.id);
        }}
        onFocus={(event) => event.stopPropagation()}
      >
        <Box
          align="center"
          direction="row"
          gap="xsmall"
          pad={{ vertical: "xsmall", horizontal: "small" }}
          margin="xsmall"
          background="brand"
          round="large"
        >
          <Text size="small" color="white">
            {status.name}
          </Text>
          <Box background="white" round="full" margin={{ left: "xsmall" }}>
            <FormClose
              color="brand"
              size="small"
              style={{ width: "12px", height: "12px" }}
            />
          </Box>
        </Box>
      </Button>
    );

  function handleChange({ option: nextSelected }) {
    const alreadySelected = currentValue.find((id) => id === nextSelected.id);
    if (alreadySelected) {
      onRemoveStatus(nextSelected.id);
    } else {
      props.onChange({
        target: { name: props.name, value: [...currentValue, nextSelected.id] },
      });
    }
  }

  const renderOption = (option, state) => {
    const isSelected = currentValue.find((id) => id === option.id);
    return (
      <Box
        pad="small"
        gap="small"
        background={state.active ? "active" : isSelected ? "brand" : undefined}
        direction="row"
      >
        <Text alignSelf="center">{option.name}</Text>
      </Box>
    );
  };

  return (
    <Select
      plain
      size="medium"
      placeholder={t("common.select")}
      value={currentValue}
      valueLabel={
        <Box wrap direction="row">
          {currentValueAsObjects?.length > 0 ? (
            currentValueAsObjects.map((status) => renderStatus(status))
          ) : (
            <Text color="dark-6">{t("common.select")}</Text>
          )}
        </Box>
      }
      closeOnChange={false}
      multiple
      dropHeight="medium"
      options={options || []}
      disabled={disabled}
      onChange={handleChange}
      labelKey="name"
      valueKey={{ key: "id", reduce: true }}
      onClose={() => setOptions(translatedOptions)}
      searchPlaceholder={t("common.search")}
      onSearch={(text) => {
        // The line below escapes regular expression special characters:
        // [ \ ^ $ . | ? * + ( )
        const escapedText = text.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
        // Create the regular expression with modified value which
        // handles escaping special characters. Without escaping special
        // characters, errors will appear in the console
        const exp = new RegExp("^(" + escapedText + ")", "i");
        setOptions(translatedOptions.filter((o) => exp.test(o.name)));
      }}
    >
      {renderOption}
    </Select>
  );
}

ValidStatusesSelect.propTypes = {};
ValidStatusesSelect.defaultProps = {};
